import { motion, useReducedMotion } from 'framer-motion';
import { ReactNode } from 'react';

interface SectionProps {
  id: string;
  children: ReactNode;
  className?: string;
}

// Page section with a single, consistent entrance.
const Section = ({ id, children, className = '' }: SectionProps) => {
  const reduceMotion = useReducedMotion();
  return (
    <motion.section
      id={id}
      className={`relative scroll-mt-20 ${className}`}
      initial={reduceMotion ? false : { opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      {children}
    </motion.section>
  );
};

export default Section;
